// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BbjX","col":"styles_col__1MQCw","actions":"styles_actions__1956U","conflict":"styles_conflict__1m2eB"};